const Waiting = () => {
  return (
    <div className="Waiting">
      <aside>
        <h2>Waiting for Scan</h2>
      </aside>
    </div>
  );
};

export const Empty = () => {
  return (
    <div className="Waiting Empty">
      <aside>
        <h2>Machine is Empty</h2>
      </aside>
    </div>
  );
};

export default Waiting;
